import { useState } from "react";
import { FaEyeSlash, FaEye } from "react-icons/fa";

const FormInput = (props) => {
  const [focused, setFocused] = useState(false);

  const { label, errorMessage, onChange, id, ...inputProps } = props;

  const handleFocus = (e) => {
    setFocused(true);
  };

  return (
    <div className="formInput">
      <label>{label}</label>
      {inputProps.name !== "message" ? (
        <div>
          <input
            {...inputProps}
            onChange={onChange}
            onBlur={handleFocus}
            onFocus={() =>
              inputProps.name === "confirmPassword" && setFocused(true)
            }
            focused={focused.toString()}
          />

          <span className="error">{errorMessage}</span>
        </div>
      ) : (
        <>
          <textArea
            {...inputProps}
            onChange={onChange}
            onBlur={handleFocus}
            onFocus={() =>
              inputProps.name === "confirmPassword" && setFocused(true)
            }
            focused={focused.toString()}
          />
          <span className="error">{errorMessage}</span>
        </>
      )}
    </div>
  );
};

export default FormInput;
